<template>
  <div class="toast-wrap">
    <transition-group name="list" tag="p">
      <p
        v-for="(item, index) in toasts"
        :style="{ transform: `translate(-50%,-${(index % 4) * 105}%)` }"
        :key="item.id"
        class="list-item"
      >
        {{ item.content }}
      </p>
    </transition-group>
  </div>  
</template>
<script>
export default {
  name: 'toast',
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    createRemoveToastTask(target, duration = 2000) {
      setTimeout(() => {
        this.toasts = this.toasts.filter(item => item !== target);
      }, duration);
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(item => item.id !== id);
    },
    onShowToast(content, removeId) {
      if (removeId) {
        this.removeToast(removeId);
      }
      if (content) {
        const id = Date.now() + Math.floor(Math.random() * 10000);
        const item = { id, content };
        const isMax = this.toasts.length === 3;
        if (isMax) {
          this.toasts.shift();
        }
        this.toasts.push(item);
        this.createRemoveToastTask(item);
        return id;
      }
      return null;
    },
  }
}
</script>
<style lang="scss">
.toast-wrap{
  .list-item{
    display: block;
    position: fixed;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    color: white;
    background: rgba(0, 0, 0, 0.7);
    padding: 0.5em 1em;
    border-radius: 1em;
    opacity: 1;
    font-size: 14px;
    max-width: 95vw;
    width: max-content;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: content-box;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>